// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__3QnhX","title":"Images90_title__2IMEu","images":"Images90_images__3so51"};